/**
 * OpenAI Ads standard e-commerce events — CaratBee storefront
 */
(function () {
  function safeMeasure(eventName, data, options) {
    if (!window.oaiq) {
      return;
    }
    if (options) {
      oaiq("measure", eventName, data, options);
    } else {
      oaiq("measure", eventName, data);
    }
  }

  function trackProductView() {
    var cfg = window.caratbeeOpenAIAds;
    if (!cfg || !cfg.product) {
      return;
    }

    var p = cfg.product;
    safeMeasure("contents_viewed", {
      type: "contents",
      contents: [
        {
          id: String(p.variantId || p.id),
          name: p.title,
          content_type: "product",
        },
      ],
    });
  }

  function trackAddToCart(detail) {
    var cfg = window.caratbeeOpenAIAds || {};
    var currency = cfg.currency || "USD";
    var product = (detail && detail.product) || {};
    var variantId = product.variant_id || product.id;
    var price = product.price;

    if (!variantId) {
      return;
    }

    var payload = {
      type: "contents",
      currency: currency,
      contents: [
        {
          id: String(variantId),
          name: product.product_title || product.title || "Product",
          content_type: "product",
          quantity: product.quantity || 1,
        },
      ],
    };

    if (price) {
      payload.amount = Number(price);
      payload.contents[0].amount = Number(price);
      payload.contents[0].currency = currency;
    }

    safeMeasure("items_added", payload);
  }

  function init() {
    trackProductView();

    document.addEventListener("ajaxProduct:added", function (event) {
      if (event.detail) {
        trackAddToCart(event.detail);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
